/**
 * @generated SignedSource<<6dbc19e95e282ae82f7dc30d908cd887>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type reviewQueuePage_Query$variables = Record<PropertyKey, never>;
export type reviewQueuePage_Query$data = {
  readonly bankAccounts: ReadonlyArray<{
    readonly id: string;
    readonly nickname: string;
  }>;
  readonly sourcingReview: {
    readonly boundRecords: ReadonlyArray<{
      readonly amountCents: number;
      readonly counterparty: string | null | undefined;
      readonly deltaCents: number;
      readonly entityType: string;
      readonly manual: boolean;
      readonly qboId: string;
      readonly txn: {
        readonly amount: number;
        readonly description: string | null | undefined;
        readonly id: string;
        readonly postingDate: string | null | undefined;
      };
      readonly txnDate: string | null | undefined;
    }>;
    readonly countedSumCents: number;
    readonly groups: ReadonlyArray<{
      readonly count: number;
      readonly counted: number;
      readonly countedSumCents: number;
      readonly counterparty: string;
      readonly matchable: number;
      readonly recommendedAction: string | null | undefined;
      readonly shape: string | null | undefined;
      readonly sumCents: number;
      readonly uncounted: number;
      readonly uncountedSumCents: number;
      readonly withCandidates: number;
    }>;
    readonly items: ReadonlyArray<{
      readonly amountCents: number;
      readonly candidates: ReadonlyArray<{
        readonly deltaCents: number;
        readonly exact: boolean;
        readonly payee: boolean;
        readonly rivalCounterparty: string | null | undefined;
        readonly rivalDate: string | null | undefined;
        readonly txn: {
          readonly amount: number;
          readonly description: string | null | undefined;
          readonly id: string;
          readonly postingDate: string | null | undefined;
        };
      }>;
      readonly category: string | null | undefined;
      readonly counterparty: string | null | undefined;
      readonly deletedInQbo: boolean;
      readonly entityType: string;
      readonly qboId: string;
      readonly txnDate: string | null | undefined;
      readonly verdict: string;
    }>;
    readonly progress: {
      readonly decidedGroups: number;
      readonly decidedRecords: number;
      readonly openGroups: number;
      readonly resolvedCents: number;
      readonly since: any | null | undefined;
    };
    readonly recentDecisions: ReadonlyArray<{
      readonly action: string;
      readonly count: number;
      readonly decidedAt: any | null | undefined;
      readonly entityType: string | null | undefined;
      readonly expectedState: string | null | undefined;
      readonly id: string;
      readonly label: string;
      readonly qboId: string | null | undefined;
      readonly reason: string | null | undefined;
      readonly runId: string | null | undefined;
      readonly sumCents: number;
      readonly undoable: boolean;
    }>;
    readonly reversals: ReadonlyArray<{
      readonly amountCents: number;
      readonly category: string | null | undefined;
      readonly counterparty: string | null | undefined;
      readonly depositQboId: string;
      readonly purchaseQboId: string;
      readonly txnDate: string | null | undefined;
    }>;
    readonly run: {
      readonly currentObject: string | null | undefined;
      readonly errorMessage: string | null | undefined;
      readonly jobId: number;
      readonly outcome: ReadonlyArray<{
        readonly key: string;
        readonly value: string;
      }>;
      readonly phase: string | null | undefined;
      readonly rowsProcessed: number;
      readonly rowsTotal: number | null | undefined;
      readonly status: string;
      readonly unit: string | null | undefined;
    } | null | undefined;
    readonly totalCount: number;
    readonly uncountedSumCents: number;
    readonly unionActivated: boolean;
  } | null | undefined;
};
export type reviewQueuePage_Query = {
  response: reviewQueuePage_Query$data;
  variables: reviewQueuePage_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countedSumCents",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uncountedSumCents",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unionActivated",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountJob",
  "kind": "LinkedField",
  "name": "run",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phase",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentObject",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowsProcessed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowsTotal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountJobOutcome",
      "kind": "LinkedField",
      "name": "outcome",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "SourcingReviewProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "since",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "decidedRecords",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "decidedGroups",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openGroups",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "resolvedCents",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "counterparty",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sumCents",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "SourcingReviewGroup",
  "kind": "LinkedField",
  "name": "groups",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "withCandidates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "counted",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uncounted",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shape",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recommendedAction",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "qboId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityType",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountCents",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "txnDate",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deltaCents",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "QboBankTxn",
  "kind": "LinkedField",
  "name": "txn",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postingDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "SourcingBoundRecord",
  "kind": "LinkedField",
  "name": "boundRecords",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    (v11/*: any*/),
    (v12/*: any*/),
    (v13/*: any*/),
    (v6/*: any*/),
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "manual",
      "storageKey": null
    },
    (v16/*: any*/)
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "category",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "SourcingReversal",
  "kind": "LinkedField",
  "name": "reversals",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "purchaseQboId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "depositQboId",
      "storageKey": null
    },
    (v13/*: any*/),
    (v12/*: any*/),
    (v6/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "SourcingRecentDecision",
  "kind": "LinkedField",
  "name": "recentDecisions",
  "plural": true,
  "selections": [
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "runId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "action",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    (v10/*: any*/),
    (v11/*: any*/),
    (v7/*: any*/),
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "decidedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "undoable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expectedState",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reason",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "verdict",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedInQbo",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "SourcingBindCandidate",
  "kind": "LinkedField",
  "name": "candidates",
  "plural": true,
  "selections": [
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "exact",
      "storageKey": null
    },
    (v14/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "payee",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rivalCounterparty",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rivalDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "BankAccount",
  "kind": "LinkedField",
  "name": "bankAccounts",
  "plural": true,
  "selections": [
    (v15/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nickname",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "reviewQueuePage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcingReview",
        "kind": "LinkedField",
        "name": "sourcingReview",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/),
          (v17/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcingReviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v21/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v6/*: any*/),
              (v18/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v24/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "reviewQueuePage_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SourcingReview",
        "kind": "LinkedField",
        "name": "sourcingReview",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/),
          (v17/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SourcingReviewItem",
            "kind": "LinkedField",
            "name": "items",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              (v11/*: any*/),
              (v21/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v6/*: any*/),
              (v18/*: any*/),
              (v22/*: any*/),
              (v23/*: any*/),
              (v15/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      },
      (v24/*: any*/)
    ]
  },
  "params": {
    "cacheID": "75c56e5a7ec1fabdbbf7a784450fe88c",
    "id": null,
    "metadata": {},
    "name": "reviewQueuePage_Query",
    "operationKind": "query",
    "text": "query reviewQueuePage_Query {\n  sourcingReview {\n    totalCount\n    countedSumCents\n    uncountedSumCents\n    unionActivated\n    run {\n      jobId\n      status\n      phase\n      currentObject\n      rowsProcessed\n      rowsTotal\n      unit\n      errorMessage\n      outcome {\n        key\n        value\n      }\n    }\n    progress {\n      since\n      decidedRecords\n      decidedGroups\n      openGroups\n      resolvedCents\n    }\n    groups {\n      counterparty\n      count\n      sumCents\n      withCandidates\n      matchable\n      counted\n      countedSumCents\n      uncounted\n      uncountedSumCents\n      shape\n      recommendedAction\n    }\n    boundRecords {\n      qboId\n      entityType\n      amountCents\n      txnDate\n      counterparty\n      deltaCents\n      manual\n      txn {\n        id\n        amount\n        postingDate\n        description\n      }\n    }\n    reversals {\n      purchaseQboId\n      depositQboId\n      txnDate\n      amountCents\n      counterparty\n      category\n    }\n    recentDecisions {\n      id\n      runId\n      action\n      label\n      qboId\n      entityType\n      count\n      sumCents\n      decidedAt\n      undoable\n      expectedState\n      reason\n    }\n    items {\n      qboId\n      entityType\n      verdict\n      amountCents\n      txnDate\n      counterparty\n      category\n      deletedInQbo\n      candidates {\n        txn {\n          id\n          amount\n          postingDate\n          description\n        }\n        exact\n        deltaCents\n        payee\n        rivalCounterparty\n        rivalDate\n      }\n      id\n    }\n    id\n  }\n  bankAccounts {\n    id\n    nickname\n  }\n}\n"
  }
};
})();

(node as any).hash = "5439eac718e42d49b217092657472e70";

export default node;
